import { Stack } from '@fluentui/react';
import React from 'react';

interface IOptionsSelectionToggleProps {
    options: { key: string; text: string }[];
    selectedKey: string;
    onChange: (key: string) => void;
}

const OptionSelectionToggle: React.FC<IOptionsSelectionToggleProps> = (props) => {
    return (
        <Stack horizontal style={{marginBottom: '1em'}}>
            {props.options.map(option => (
                <div
                    key={option.key}
                    className={`option-item${option.key === props.selectedKey ? ' selected' : ''}`}
                    onClick={() => props.onChange(option.key)}
                    style={{
                        flexGrow: 1,
                        padding: '1em',
                        textAlign: 'center',
                        cursor: 'pointer',
                        borderWidth: '1px',
                        borderStyle: 'solid',
                        borderColor: option.key === props.selectedKey ? 'rgb(120, 156, 47)' : '#ccc',
                        backgroundColor: option.key === props.selectedKey ? 'rgb(120, 156, 47)' : '#fff',
                        color: option.key === props.selectedKey ? '#fff' : '#000',
                        fontWeight: option.key === props.selectedKey ? 'bold' : 'normal',
                    }}
                >
                    {option.text}
                </div>
            ))}
        </Stack>
    );
}

export default OptionSelectionToggle;